import axios from 'axios'
import API_URL from '@/router/api'

export const findMany = (ctx, query = {}) => {
    return new Promise((resolve, reject) => {

        axios.get(API_URL.blogs.findMany, { params: query })
            .then(resolve)
            .catch(reject)
    })
}
